<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TxF536/tc-custom/9781460312483.jpg?1705010289062" alt="This image is the cover for the book Beauty Within, The Armstrong Sisters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beauty Within, The Armstrong Sisters
      </h1>
      <p class="bookDescription body article font2">
        <i>Beauty is in the eye of the beholder</i><br/><br/>Considered the plain, <i>clever</i> one in her family, Lady Cressida Armstrong knows her father has given up on her ever marrying. But who needs a husband when science is the only thing to set Cressie's pulse racing?<br/><br/>Disillusioned artist Giovanni di Matteo is setting the <i>ton</i> abuzz with his expertly executed portraits. Once his art was inspired; now it's only technique. Until he meets Cressie.<br/><br/>Challenging, intelligent and yet insecure, Cressie is the one whose face and body he dreams of capturing on canvas. In the enclosed, intimate world of his studio, Giovanni rediscovers his passion as he awakens hers.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marguerite Kaye
      </h2>
      
      <p class="authorDescription body article">Marguerite Kaye has written over fifty historical romances featuring feisty heroines and a strong sense of place and time. She is also co-author with Sarah Ferguson, Duchess of York, of the Sunday Times bestseller, <I>Her Heart for a Compass</I>. They are currently working on their second book together. Marguerite lives in Argyll on the west coast of Scotland. When not writing, she loves to read, cook, garden, drink martinis, and sew, though rarely at the same time.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4326e750